import store from '@/store'
import { auth } from '@/auth/hyper-auth'
import { getUserRights } from './service'
import { PROVIDED_SERVICES, BASE_SERVICES } from '@/service'

const withoutServicePage = (to) => {
    const freepass = [
        'notices', 'noticeView',
        'agreement', 'infomation'
        // 'payment-card', 'payment-card-result',
        // 'register-card', 'cancel-registered-card', 'register-card-receive'
    ]
    return freepass.includes(to.name)
}

const isUserMonths = async () => {
    const userRights = getUserRights()
    if (userRights && userRights.length && !store.getters.months.length) {
        await store.dispatch('getMonths', userRights[0].serviceIdx)
    }
    return Promise.resolve(store.getters.months.length > 0)
}
const getRouteForUserFromAdmin = async (params) => {
    const { email, adminIdx, userIdx, token } = params
    localStorage.setItem(auth.authConfig.storageTokenKeyName, token)
    try {
        await store.dispatch('createTokenAdminAuth', { email, adminIdx, userIdx })
        return getRouteForLoggedInUser()
    } catch (error) {
        return { name: 'auth-login' }
    }
}

const getRouteForUserFromAuthCenter = async (params) => {
    const { email, token } = params
    localStorage.setItem(auth.authConfig.storageTokenKeyName, token)
    try {
        await store.dispatch('createTokenAuth', { email })
        return getRouteForLoggedInUser()
    } catch (error) {
        return { name: 'auth-login' }
    }
}

const getRouteForLoggedInUser = () => {
    const userRights = getUserRights()
    const requireTc = isTcPopsLogin()
    if (userRights && userRights.length) {
        const services = userRights.map(item => PROVIDED_SERVICES[item.serviceName]).concat(BASE_SERVICES.default).sort((a, b) => a.order - b.order)
        return { name: services[0].route }
    } else if (requireTc) {
        return { name: 'agreement' }
    } else {
        return { name: 'infomation' }
    }
}

const isTcPopsLogin = () => store.getters.authPrerequisites.includes('tc') && process.env.VUE_APP_POPS_LOGIN === 'TRUE'

export {
    withoutServicePage,
    isUserMonths,
    isTcPopsLogin,
    getRouteForUserFromAdmin,
    getRouteForUserFromAuthCenter,
    getRouteForLoggedInUser
}
